import { render, staticRenderFns } from "./CommentDisplay.vue?vue&type=template&id=713c973b&scoped=true&"
import script from "./CommentDisplay.vue?vue&type=script&lang=js&"
export * from "./CommentDisplay.vue?vue&type=script&lang=js&"
import style0 from "./CommentDisplay.vue?vue&type=style&index=0&id=713c973b&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713c973b",
  null
  
)

export default component.exports